export default __webpack_public_path__ + "static/media/favicon.c9b38880.ico";